import React from "react";
import {
  Alert,
  DuplicateIcon,
  IconButton,
  Snackbar,
  Stack,
  styled,
  Typography,
} from "convertupleads-theme";

const StyledBox = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: theme.spacing(0.5),
  gap: theme.spacing(0.5),
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: theme.spacing(1),
  width: "100%",
  height: 70,
  position: "relative",
  "& .sgd_copyIcon": {
    position: "absolute",
    top: 2,
    right: 2,
    visibility: "hidden",
    pointerEvents: "none",
    transition: "all 0.3s ease",
  },
  "&:hover": {
    "& .sgd_copyIcon": {
      visibility: "visible",
      pointerEvents: "all",
    },
  },
}));

const IconTitle = ({ icon, title }) => {
  const [open, setOpen] = React.useState(false);

  const clickHandler = () => {
    navigator.clipboard.writeText(title);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <StyledBox>
      {icon}
      <Typography
        variant="caption"
        color={"text.secondary"}
        noWrap
        sx={{ display: "block", width: "100%" }}
        title={title}
      >
        {title}
      </Typography>
      <IconButton
        size={"small"}
        className={"sgd_copyIcon"}
        onClick={clickHandler}
      >
        <DuplicateIcon color={"primary"} sx={{ fontSize: "14px !important" }} />
      </IconButton>
      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert variant={"filled"} severity="success" onClose={handleClose}>
          Copied!
        </Alert>
      </Snackbar>
    </StyledBox>
  );
};

export default IconTitle;
